import { render, staticRenderFns } from "./FormPages.vue?vue&type=template&id=39d1f6b4&scoped=true&"
import script from "./FormPages.vue?vue&type=script&lang=js&"
export * from "./FormPages.vue?vue&type=script&lang=js&"
import style0 from "./FormPages.vue?vue&type=style&index=0&id=39d1f6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1f6b4",
  null
  
)

export default component.exports